import get from 'lodash-es/get';
import mapKeys from 'lodash-es/mapKeys';
import set from 'lodash-es/set';
import { hasAds } from 'mk/bazaar/common/userUtils';
import * as React from 'react';
import { hbGetZoneId, ZoneTargeting } from './hb';

declare const window;

export interface OldFluxibleContext {
    requestUser: any; // UserEntity;
    oxZones: {[zoneName: string]: string[]};
    hbTargeting: {[zoneName: string]: ZoneTargeting};
}

interface OwnProps {
    context: OldFluxibleContext;
    zoneName: string;
    className: string;
    targeting?: ZoneTargeting;
    style?: React.CSSProperties;
    htmlData?: {[key: string]: string};
    forceShowAds?: boolean;

    // use if there's no need to initial registering of the ad slot into the props.context.oxZones
    mountWithoutRegistering?: boolean;
    slotRef?(div: HTMLDivElement);
}

export class AdSlot extends React.Component<OwnProps> {

    private container: HTMLDivElement;

    public static shouldComponentUpdate() {
        return false;
    }

    public render() {
        const { context, zoneName, className, style, htmlData, forceShowAds, slotRef } = this.props;

        if (!forceShowAds && !hasAds(context.requestUser)) {
            return null;
        }

        const zoneId = hbGetZoneId(zoneName);
        const dataAttributes = mapKeys(htmlData, (value, key) => `data-${key}`);

        return (
            // potrebujeme placeholder element, aby sme mali kam zavesit
            // <iframe> v componentDidMount()
            <div
                id={zoneId}
                className={className}
                style={style}
                ref={(r) => {
                    this.container = r;
                    if (slotRef) {
                        slotRef(r);
                    }
                }}
                {...dataAttributes}
            />
        );
    }

    public componentWillMount() {
        if (this.props.mountWithoutRegistering) {
            return null;
        }

        // zone has been added, remember change
        const changes = get<{[zoneName: string]: string[]}, string, string[]>(this.props.context.oxZones, this.props.zoneName, []);
        changes.push('add');
        set(this.props.context.oxZones, this.props.zoneName, changes);

        if (this.props.context.hbTargeting) {
            this.props.context.hbTargeting[this.props.zoneName] = this.props.targeting;
        }

        // console.log('AdSlot will mount ' + this.props.zoneName);
    }

    public componentWillUnmount() {
        // zone has been removed, remember change
        const changes = get<{[zoneName: string]: string[]}, string, string[]>(this.props.context.oxZones, this.props.zoneName, []);
        changes.push('remove');
        set(this.props.context.oxZones, this.props.zoneName, changes);

        if (this.props.context.hbTargeting) {
            delete this.props.context.hbTargeting[this.props.zoneName];
        }

        if (this.container) {
            // We are returning null from render in some cases - so ref is never called and this.container is undefined
            let removeEvent;
            if (typeof window.CustomEvent === 'function') {
                removeEvent = new CustomEvent('slotWillUnmount');
            } else { // CustomEvent not implemented in IE 9, 10, 11
                removeEvent = document.createEvent('CustomEvent');
                removeEvent.initCustomEvent('slotWillUnmount', false, false, undefined);
            }
            this.container.dispatchEvent(removeEvent);
        }
        // console.log('AdSlot will unmount ' + this.props.zoneName);
    }
}
